import type { ComponentProps } from 'react';
import { cn } from '../lib/cn';

/**
 * Tabela (Ustawienia → Zespół): nagłówki Caption muted, wiersze z linią pod spodem, bez ramek.
 * Opakowanie jest `relative`: elementy `sr-only` (position: absolute) w komórkach zostają w kontenerze
 * z przewijaniem i nie poszerzają strony.
 */
export function Table({ className, ...props }: ComponentProps<'table'>) {
  return (
    <div className="relative w-full overflow-x-auto">
      <table className={cn('w-full border-collapse text-left text-body-s', className)} {...props} />
    </div>
  );
}

export function THead({ className, ...props }: ComponentProps<'thead'>) {
  return <thead className={cn(className)} {...props} />;
}

export function TBody({ className, ...props }: ComponentProps<'tbody'>) {
  return <tbody className={cn(className)} {...props} />;
}

export function Tr({ className, ...props }: ComponentProps<'tr'>) {
  return <tr className={cn('border-b border-line', className)} {...props} />;
}

export function Th({ className, align, ...props }: ComponentProps<'th'> & { align?: 'left' | 'right' | 'center' }) {
  return (
    <th
      scope="col"
      className={cn(
        'h-9 px-1 align-middle text-caption font-medium whitespace-nowrap text-fg-muted first:pl-1 last:pr-1',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        className,
      )}
      {...props}
    />
  );
}

export function Td({ className, align, ...props }: ComponentProps<'td'> & { align?: 'left' | 'right' | 'center' }) {
  return (
    <td
      className={cn(
        'h-16 px-1 align-middle text-fg',
        align === 'right' && 'text-right',
        align === 'center' && 'text-center',
        className,
      )}
      {...props}
    />
  );
}
